import { toast, ToastOptions } from "react-toastify";

const defaults: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
};

export const notify = {
  success: (message: string, options?: ToastOptions) =>
    toast.success(message, { ...defaults, ...options }),
  error: (message: string, options?: ToastOptions) =>
    toast.error(message, { ...defaults, ...options }),
  warning: (message: string, options?: ToastOptions) =>
    toast.warning(message, { ...defaults, ...options }),
  info: (message: string, options?: ToastOptions) =>
    toast.info(message, { ...defaults, ...options }),
};
